<template>
  <div
    :id="`${name}_card-wrapper`"
    class="radio-group-field"
    :class="[wrapperStyle.class]"
    :style="[wrapperStyle.style]"
  >
    <div
      class="card"
      :class="[cardStyle.class]"
      :style="[cardStyle.style]"
    >
      <div class="card-content">
        <div class="card-title" v-if="titleText" v-html="titleText">        
        </div>
        <div class="card-image">
          <img :src="fieldValue.localImage" alt="" srcset="" />
        </div>
        <div class="label-text">
          {{ label }}
        </div>
    <form action="#" class="custom-range"
      :style="{
            '--color-one': optOne.activeColor || 'red',
            '--color-two': optTwo.activeColor || 'blue',
          }">
        <p class="range-field z-depth-1">
          <input type="range" id="select_range" v-model="selectRangeX" min="1" max="2" step="1" />
        </p>
    </form>

        <div class="btn-container">
          <button
            class="btn  waves-effect "
            @click="$_setSelected(optOne)"
            :class="[
              fieldValue.value === optOne.value
                ? 'z-depth-0'
                : '',
            ]"
            :style="[
              {
                background:
                  fieldValue.value === optOne.value ? '#fff' : optOne.activeColor ,
              },
              {
                color:
                  fieldValue.value === optOne.value
                    ?  optOne.activeColor
                    : '#fff' 
              },
            ]"
          >
            {{ optOne.buttonText }}
          </button>

          <button
            class="btn waves-effect right"
            @click="$_setSelected(optTwo)"
            :class="[
              fieldValue.value === optTwo.value
                ? 'z-depth-0'
                : '',
              ,
            ]"
            :style="[
              {
                background:
                  fieldValue.value === optTwo.value ? '#fff' : optTwo.activeColor
              },
              {
                color:
                  fieldValue.value === optTwo.value
                    ? optTwo.activeColor
                    : '#fff' 
              },
            ]"
          >
            {{ optTwo.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CustomRadioField",

  props: {
    value: {
      type: [Object],
      default: () => ({}),
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    titleText: {
      type: String,
      default: () => "",
    },

    gridStyle: {
      type: [Object],
      default: () => ({}),
    },
    showLabel: {
      type: Boolean,
      default: true,
      required: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },

    helperText: {
      type: String,
      required: false,
      default: "",
    },
    autoComplete: {
      type: Boolean,
      default: () => true,
    },
    wrapperStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    cardStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },

    fieldStyle: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    icon: {
      type: String,
      required: false,
    },
    groupTag: {
      type: String,
      default: () => "",
    },
    error: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
      reuqired: false,
    },
  },
  data() {
    return {
      fieldValue: this.value,
      selectRange: '1',
      showList: false,
    }
  },
  mounted() {
    this.$_setValue();
    this.value.value === this.options[0].value 
    ? this.selectRange = 1
      : this.value.value === this.options[1].value 
       ? this.selectRange = 2
       : false 
    console.log(this.value.value === this.options[0].value)
  },
  computed: {
    selectRangeX: {
      get () {
        return this.selectRange
      },
      set (e) {
        this.selectRange = e
        this.$_setSelected(this.currentOption)
        
      }
    },
    currentOption: {
      get () {
        return this.selectRange === '1' 
        ? this.options[0]
        : this.options[1] 
      }
    },
    optOne() {
      return this.options[0];
    },
    optTwo() {
      return this.options[1];
    },
  },
  watch: {
    currentOption: function(nV) {
    /*   this.$_setSelected(nV) */
    }
  },
  methods: {
    $_setValue() {
      const ObjLen = Object.keys(this.value).length
      if (ObjLen <= 0) {
        this.fieldValue = this.optOne
      }
    
    },
    $_setSelected(item) {
      if (this.fieldValue.value === item.value) return
      this.fieldValue = item
      item.value === this.optOne.value 
      ? this.selectRange = 1
      : this.selectRange = 2
      this.$_updateValue()
    },
    $_updateValue() {
      this.$emit("update", this.fieldValue)
    },
   /*  $_getImg(pic) {
      if (pic) {
        return require("/assets/" + pic);
      }
    }, */
  },
};
</script>
<style lang="scss" scoped>


  /* 
  &::before {
    content: '';
    margin: -1px -1px 0 0;
    width: calc(100% + 2px);
    height: calc(100% + 2px);
    color: rgb(255,255,255);
  } */
.card {
  .custom-range {
    position: relative;
    &::before {
      content: ' ';
      height: 2px;
      width: calc(50% - 69px);
      background: #ffffff;
      top: 9px;
      z-index: 9;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
    p {
      text-align: center;
      position: relative;
      background: linear-gradient(45deg, var(--color-one), var(--color-two));
      border-radius: 44px;
      text-align: center;
      &::before {
        content: ' ';
        width: calc(25% - 25px);
        height: 2px;
        background: white;
        position: absolute;
        left: 14px;
        top: 9px;
      }
      &::after {
        content: ' ';
        width: calc(25% - 25px);
        height: 2px;
        background: white;
        position: absolute;
        right: 14px;
        top: 9px;
        }
      input[type=range] {
        width: 50%;
        border: none;
        margin:0px;
        padding:0px;
        transform: translateY(-4px);
      }
      input[type=range]::-webkit-slider-runnable-track {
        background: rgba(255, 255, 255, 0);
        height: 1px;
      }
      input[type=range]::-moz-range-track {
        background: rgba(255, 255, 255, 0);
        height: 1px;
      }
   
    input[type=range]::-webkit-slider-thumb {
      width: 24px;
      background: rgb(235, 235, 235);
      height: 24px;
      position: relative;
      transform: translateY(-6px);
      border: 6px solid white;
      box-shadow:  0 2px 2px 0 rgba(0, 0, 0, 0.08), 0 3px 1px -2px rgba(0, 0, 0, 0.06), 0 1px 5px 0 rgba(0, 0, 0, 0.099);;
    }
  }
  }
  .card-title {
    font-size: 18px;
  }
  .card-content {
    .label-text {
      margin-top: 12px;
    } 
    .radio-bar {
      padding: 0 1rem;
      border-radius: 25px;
      margin-top: 1rem;
      height: 15px;

      //   background-image: linear-gradient(to right, #76fee2, #f8d677);
      background-image: linear-gradient(
        to right,
        var(--gradOne),
        var(--gradTwo)
      );
      display: flex;
      .line-bar-wrapper {
        height: 100%;
        display: flex;
        align-items: center;

        .line-bar {
          height: 2px;
          width: 100%;
          border-radius: 25px;
          background: #fff;
        }
      }

      .lb-start,
      .lb-end {
        width: 20%;
      }

      .lb-center {
        width: 30%;
      }
      .radio-wrapper {
        position: relative;
        width: 15%;

        padding: 5px;

        .out-layer {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 50%;
          height: 25px;
          width: 25px;
          //   background: #fff;
          display: flex;
          justify-content: center;
          align-items: center;

          .inner-layer {
            height: 12.5px;
            width: 12.5px;
            border-radius: 50%;
            background: #f1f1f1;
          }
        }
      }
    }

    .btn-container {
      margin: 16px 0;
      button {
        min-width: 140px;
      }
    }
  }
}
</style>
